export default {
  'site-name': 'Gifta Blog',
  'site-title': 'Gifta Blog',
  'gifta-site-title': 'Gifta Website',
  'gifta-site-link': 'https://www.gifta.fr/',
  'pixa-site-title': 'Pixartprinting Website',
  'pixa-site-link': 'https://www.pixartprinting.fr/',
  'load-more-article': 'Lis d’autres articles',
  'next-slide': 'Suivant',
  'prev-slide': 'Précédent',
  'next-pagination': 'Suivants',
  'prev-pagination': 'Précédents',
  'next-article': 'Article suivant',
  'related-articles': 'Articles associés',
  'back-to-top': 'Revenir en haut',
  search: 'Cerca',
  'erase-research': 'Effacer la recherche',
  close: 'Fermer',
  'newsletter-title': 'Newsletter',
  'newsletter-text':
    'Sii tra i primi ad essere aggiornato <br> sulle novità di Gifta blog.',
  'newsletter-cta': 'Inscris-toi',
}
